import { Lock, Video } from "lucide-react";
import { useTranslate } from "ra-core";
import type { Identifier } from "ra-core";

import { useTaskMeeting } from "./useTaskMeeting";

export const MeetingSource = ({
  zoomMeetingId,
}: {
  zoomMeetingId?: Identifier | null;
}) => {
  const translate = useTranslate();
  const { meeting, restricted } = useTaskMeeting(zoomMeetingId);

  // The task is the reader's to see; the meeting it came from is not. LCCRM-93.
  if (restricted) {
    return (
      <div className="flex items-center gap-1 mt-1 text-xs text-muted-foreground">
        <Lock className="w-3 h-3" />
        <span>{translate("resources.tasks.restricted_meeting.source")}</span>
      </div>
    );
  }

  if (!zoomMeetingId || !meeting) return null;

  return (
    <div className="flex items-center gap-1 mt-1 text-xs text-muted-foreground">
      <Video className="w-3 h-3" />
      <span>from {meeting.meeting_topic}</span>
    </div>
  );
};
